// CL-1 RECOVERY_TABLE (omo F-8 영감) + F-11 resume marker.
//
// errorClassifier(type) → handler dispatch table. handler는 후속 CL-2/3/4가
// registerRecoveryHandler로 등록한다 (점진적 fill).
//
// 안전 강제:
//   - handler가 throw 시 catch + console.error + false 반환 (silent swallow)
//   - 미등록 type → false (recover 불가)
//   - falsy 반환 → false (caller가 fail-open 결정)
//
// 의존성: errorClassifier ERROR_TYPES (validation은 안 하지만 키 일관성을 위해 자유 string 허용)

const _handlers = new Map();

/**
 * 후속 CL phase가 호출. 같은 type에 register 시 덮어쓰기 (마지막 register 우선).
 *
 * @param {string} type     — ERROR_TYPES 값 또는 자유 string
 * @param {Function} handler — (ctx) → Promise<boolean> | boolean
 * @returns {boolean}        — register 성공 여부
 */
export function registerRecoveryHandler(type, handler) {
  if (!type || typeof type !== 'string') return false;
  if (typeof handler !== 'function') return false;
  _handlers.set(type, handler);
  return true;
}

/**
 * @param {string} type
 * @returns {Function|null}
 */
export function getRecoveryHandler(type) {
  if (!type || typeof type !== 'string') return null;
  return _handlers.get(type) ?? null;
}

/**
 * handler 호출 + safe-swallow. handler가 throw / reject 시 console.error + false.
 *
 * @param {string} type
 * @param {object} [ctx]   — handler에 그대로 전달
 * @returns {Promise<boolean>}
 */
export async function dispatchRecovery(type, ctx) {
  if (!type) return false;
  const handler = _handlers.get(type);
  if (!handler) return false;
  try {
    const result = await handler(ctx);
    return !!result;
  } catch (e) {
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
      console.error(`[dispatchRecovery] type=${type} handler threw:`, e?.message ?? e);
    }
    return false;
  }
}

/**
 * 테스트 / 모듈 재초기화용. 운영 path는 boot 시 1회 register 후 호출 X.
 */
export function clearRecoveryHandlers() {
  _handlers.clear();
}

/**
 * 등록된 handler type 목록 — 디버깅 / 진입 점검용.
 */
export function listRegisteredTypes() {
  return [..._handlers.keys()];
}

// ────────────────────────────────────────────────
// F-11 resume marker — recovery 성공 후 LLM에 push할 system message
// ────────────────────────────────────────────────

export const RESUME_MARKER = '[recovered: previous turn errored; continuing]';
